import axios from "axios";
import { ApiBasicResponse } from "../../../models/apiBasicResponse.model";
import { CreateCreditRequestDto } from "../Models/create-credit-request.models";

export const getActiveCreditTypesService = async (): Promise<ApiBasicResponse> => {
  const url = process.env.REACT_APP_API_HOST + `credits/get-Types-Credit`;
  const responseWithAxios = await axios.get(url);
  return responseWithAxios.data;
}

export const createCreditRequestService = async (
  idUser: number,  
  data: CreateCreditRequestDto
): Promise<ApiBasicResponse> => {  
    const url = process.env.REACT_APP_API_HOST + `credits/create-credit-request/${idUser}`;
    const responseWithAxios = await axios.post(url, data);
    return responseWithAxios.data;
}